import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { Permission } from '../../model/enumeration/Permission.enum';
import { PokerRoom } from '../../model/enumeration/PokerRoom';
import History from '../../pages/History/History';
import MainExpertMode from '../ExpertMode/MainExpertMode/MainExpertMode';
import MultiTables from '../Game/MultiTables/MultiTables';
import { Paths } from './Paths';
import PermissionsWrapper from './PermissionsWrapper/PermissionsWrapper';

interface Route extends Omit<RouteObject, 'children'> {
  path: string;
  element: React.JSX.Element;
  children?: Array<Route>;
}

const Main = lazy(() => import('../../pages/Main/Main'));
const Login = lazy(() => import('../../pages/Login/Login'));
const Dashboard = lazy(() => import('../../pages/Dashboard/Dashboard'));
const ManageBotSeating = lazy(
  () => import('../../pages/Dashboard/ManageBotSeating/ManageBotSeating'),
);
const ManageBotLinkSeating = lazy(
  () =>
    import('../../pages/Dashboard/ManageBotLinkSeating/ManageBotLinkSeating'),
);
const ManageBotParams = lazy(
  () => import('../../pages/Dashboard/ManageBotParams/ManageBotParams'),
);
const ManageAccounts = lazy(
  () => import('../../pages/Dashboard/ManageAccounts/ManageAccounts'),
);

export const getRouterConfig = (
  expertMode: boolean | undefined,
  room: PokerRoom,
): Route[] => [
  {
    path: Paths.MAIN,
    element: <Main />,
    children: [
      ...(expertMode !== undefined
        ? [
            {
              path: Paths.MAIN,
              element: expertMode ? <MainExpertMode /> : <MultiTables />,
            },
          ]
        : []),
      {
        path: Paths.DASHBOARD,
        element: (
          <PermissionsWrapper
            permissions={[
              Permission.MANAGE_ACCOUNTS,
              Permission.MANAGE_BOTS_SEATING,
              Permission.MANAGE_BOTS_PARAMS,
              Permission.CHANGE_BOTS_CLUBS,
              Permission.RESET_BOTS_RESTRICTIONS,
            ]}
          >
            <Dashboard />
          </PermissionsWrapper>
        ),
        children: [
          {
            path: Paths.MANAGE_ACCOUNTS,
            element: (
              <PermissionsWrapper permissions={[Permission.MANAGE_ACCOUNTS]}>
                <ManageAccounts />
              </PermissionsWrapper>
            ),
          },
          {
            path: Paths.MANAGE_BOT_SEATING,
            element: (
              <PermissionsWrapper
                permissions={[Permission.MANAGE_BOTS_SEATING]}
              >
                {room === PokerRoom.PokerNow ? (
                  <ManageBotLinkSeating />
                ) : (
                  <ManageBotSeating />
                )}
              </PermissionsWrapper>
            ),
          },
          {
            path: Paths.MANAGE_BOT_PARAMS,
            element: (
              <PermissionsWrapper
                permissions={[
                  Permission.MANAGE_BOTS_PARAMS,
                  Permission.CHANGE_BOTS_CLUBS,
                  Permission.RESET_BOTS_RESTRICTIONS,
                ]}
              >
                <ManageBotParams />
              </PermissionsWrapper>
            ),
          },
        ],
      },
      {
        path: Paths.HISTORY,
        element: <History />,
      },
    ],
  },
  {
    path: Paths.LOGIN,
    element: <Login />,
  },
];
